module.exports = __webpack_public_path__ + "img/elxz3.3965f8c0.jpg";